export { MB_deviceInfo, MB_deviceInfoInitialize, MB_deviceInfoisInitialized, isMobile, isMobileApp, isEmulator } from './MB_deviceInfo';
